export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Caça Palavras',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Jogo',
    button: {
      add: 'Novo jogo',
    },
  },
  list: {
    title: 'Caça Palavras',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  card: {
    title: 'Gerador de Caça Palavras',
    actions: 'Ações',
    defaultSettings: 'Configurações padrão',
  },
  table: {
    title: 'Jogos Ativos',
    searchPlaceholder: 'Procurar por algo...',
    groupedTooltip: 'Este grupo contém vários Caça-Palavras.',
  },
  form: {
    name: {
      label: 'Nome:',
      invalid: 'Nome é obrigatório',
    },
    enableGroupedGeneration: {
      label: 'Gerar vários jogos de uma vez',
      tooltip: 'Permite criar vários jogos de caça-palavras ao mesmo tempo.',
    },
    rows: {
      label: 'Tamanho linhas:',
      placeholder: 'Quantidade de linhas',
    },
    columns: {
      label: 'Tamanho colunas:',
      placeholder: 'Quantidade de colunas',
    },
    positions: {
      label: 'Posicionamento das palavras',
      horizontal: 'Horizontal',
      vertical: 'Vertical',
      diagonal: 'Diagonal',
      inverted: 'Invertida',
      invertedHorizontal: 'Horizontal Invertida',
      invertedVertical: 'Vertical Invertida',
      invertedDiagonal: 'Diagonal Invertida',
    },
    enableSubWord: {
      label: 'Evitar palavra e sub-palavra',
    },
    showGrid: {
      label: 'Mostrar Grade',
    },
    showWordPositions: {
      label: 'Destacar Palavras',
    },
    highlightMode: {
      color: 'Cor de Fundo',
      border: 'Borda Suave',
    },
    wordsList: {
      label: 'Lista de Palavras (uma por linha)',
    },
    totalWords: {
      label: 'Total de palavras:',
    },
    game: 'Jogo {n}',
  },
  button: {
    generateAgain: 'Gerar novamente',
    openAll: 'Abrir todos',
    closeAll: 'Fechar todos',
  },
  sidebar: {
    exportHint: 'Você precisa salvar antes de exportar.',
    defaultFileName: 'caça-palavras',
  },
  popover: {
    title: 'Palavras posicionadas',
    description: 'foram utilizadas no caça-palavras',
  },
  alert: {
    wordsTooBig: {
      intro:
        'As seguintes palavras são maiores que o espaço disponível no <strong>jogo {gameNumber}</strong>:',
    },
  },
};
